import {createApp} from 'vue'
import {gsap} from "gsap";

function initMiniCart() {
    const divs = document.querySelectorAll('.appMiniCart');
    if (divs.length > 0) {
        divs.forEach((div) => {
            const app = createApp({
                name: "Mini Cart" + div.dataset.unique,
                data() {
                    return {
                        appReady: false,
                        refreshKey: 0,
                        showAddPreview: false,
                        bubble: false,
                    }
                },
                computed: {
                    products() {
                        let storage = JSON.parse(localStorage.getItem('webien_cart'));
                        let list = [];
                        if (storage && storage.hasOwnProperty('products')) {
                            if(!Object.keys(storage.products)) return list;
                            list = storage.products;
                        }
                        this.refreshKey; // Force refresh
                        return list;
                    },
                    cartCount() {
                        let app = this;
                        if(!Object.keys(app.products)) return 0;
                        let p = Object.values(app.products).filter(product => !product.required);
                        //return p.length
                        return Object.values(app.products).length;
                    }
                },
                watch: {},
                methods: {
                    refresh() {

                        let app = this;
                        this.refreshKey++;

                        let el = document.getElementById('appMiniCart_' + div.dataset.unique);

                        if (el) {
                            app.bubble = true;
                            setTimeout(function () {
                                app.bubble = false;
                            }, 250);
                        }

                    },
                    closePreview() {
                        gsap.to(".add-preview", {transform: 'translateY(0)', opacity: 0, duration: 0.2, ease: "power.out"});
                        gsap.to(".add-preview", {transform: 'translateY(-500px)', duration: 0, delay: 0.2});
                    },
                    showPreview() {
                        let app = this;
                        let menuOffset = 60;
                        gsap.to(".add-preview", {transform: 'translateY(0)', duration: 0});
                        gsap.to(".add-preview", {transform: 'translateY(' + menuOffset + 'px)', opacity: 1, delay: 0.1, duration: 0.3, ease: "power.in"});

                        setTimeout(function () {
                            app.closePreview();
                        }, 5000)
                    }

                },
                mounted: function () {
                    this.appReady = true;
                    let app = this;

                    window.addEventListener("cartUpdated", function(event) {
                        app.refresh();
                    });

                    window.addEventListener("cartAdded", function(event) {
                        app.showPreview();
                    });


                },
                created() {

                },
                components: {}
            });

            if (document.getElementById('appMiniCart_' + div.dataset.unique)) {
                app.mount('#appMiniCart_' + div.dataset.unique);
            }
        });
    }
}
initMiniCart();


jQuery( document ).on( 'elementor/popup/show', () => {
    //initMiniCart();
} );